var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18571 0.5H2.17143C1.24833 0.5 0.5 1.24833 0.5 2.17143V7.18571C0.5 8.10881 1.24833 8.85714 2.17143 8.85714H7.18571C8.10881 8.85714 8.85714 8.10881 8.85714 7.18571V2.17143C8.85714 1.24833 8.10881 0.5 7.18571 0.5Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8888 12.2002H13.8746C12.9515 12.2002 12.2031 12.9485 12.2031 13.8716V18.8859C12.2031 19.809 12.9515 20.5573 13.8746 20.5573H18.8888C19.812 20.5573 20.5603 19.809 20.5603 18.8859V13.8716C20.5603 12.9485 19.812 12.2002 18.8888 12.2002Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3817 0.5C16.3817 0.5 20.5603 0.5 20.5603 4.67857C20.5603 4.67857 20.5603 8.85714 16.3817 8.85714C16.3817 8.85714 12.2031 8.85714 12.2031 4.67857C12.2031 4.67857 12.2031 0.5 16.3817 0.5Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67857 12.2002C4.67857 12.2002 8.85714 12.2002 8.85714 16.3788C8.85714 16.3788 8.85714 20.5573 4.67857 20.5573C4.67857 20.5573 0.5 20.5573 0.5 16.3788C0.5 16.3788 0.5 12.2002 4.67857 12.2002Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.cdf698a50d2e929143361684c003e8e5.svg";
export { ForwardRef as ReactComponent };